"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyGenderGroupStatsToJSON = exports.SurveyGenderGroupStatsFromJSONTyped = exports.SurveyGenderGroupStatsFromJSON = exports.instanceOfSurveyGenderGroupStats = void 0;
var runtime_1 = require("../runtime");
var SurveyGenderType_1 = require("./SurveyGenderType");
var SurveyGroupStats_1 = require("./SurveyGroupStats");
/**
 * Check if a given object implements the SurveyGenderGroupStats interface.
 */
function instanceOfSurveyGenderGroupStats(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyGenderGroupStats = instanceOfSurveyGenderGroupStats;
function SurveyGenderGroupStatsFromJSON(json) {
    return SurveyGenderGroupStatsFromJSONTyped(json, false);
}
exports.SurveyGenderGroupStatsFromJSON = SurveyGenderGroupStatsFromJSON;
function SurveyGenderGroupStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : (0, SurveyGenderType_1.SurveyGenderTypeFromJSON)(json['gender']),
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, SurveyGroupStats_1.SurveyGroupStatsFromJSON)(json['stats']),
    };
}
exports.SurveyGenderGroupStatsFromJSONTyped = SurveyGenderGroupStatsFromJSONTyped;
function SurveyGenderGroupStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gender': (0, SurveyGenderType_1.SurveyGenderTypeToJSON)(value.gender),
        'stats': (0, SurveyGroupStats_1.SurveyGroupStatsToJSON)(value.stats),
    };
}
exports.SurveyGenderGroupStatsToJSON = SurveyGenderGroupStatsToJSON;
